import React from 'react'

const ChevronRightIcon = () => (
    <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 21L3 24L15 12L3 0L0 3L9 11.9142L0 21Z" fill="currentColor"/>
    </svg>
)

export default ChevronRightIcon
